import React from "react";

const base =
  "relative overflow-hidden bg-white/70 border border-[#e5e7eb] rounded-xl";

export const Shimmer = ({ className = "" }) => (
  <div
    className={`${base} ${className}`}
    style={{
      backgroundImage:
        "linear-gradient(90deg, rgba(243,244,246,0.0) 0%, rgba(243,244,246,1) 40%, rgba(243,244,246,0.0) 80%)",
      backgroundSize: "240% 100%",
      animation: "netluq-shimmer 1.2s ease-in-out infinite"
    }}
  />
);

export const SkeletonLine = ({ className = "" }) => (
  <Shimmer className={`h-3 rounded-full ${className}`} />
);

export const SkeletonCard = ({ className = "" }) => (
  <div className={`border border-[#e5e7eb] rounded-2xl bg-white/70 p-4 ${className}`}>
    <SkeletonLine className="w-44 mb-3" />
    <SkeletonLine className="w-full mb-2" />
    <SkeletonLine className="w-11/12 mb-2" />
    <SkeletonLine className="w-9/12" />
  </div>
);

export const SkeletonList = ({ rows = 8, className = "" }) => (
  <div className={`space-y-2 ${className}`}>
    {Array.from({ length: rows }).map((_, idx) => (
      <div key={idx} className="border border-[#e5e7eb] rounded-2xl bg-white/70 p-3">
        <div className="flex items-center gap-3">
          <Shimmer className="w-9 h-9 rounded-full" />
          <div className="flex-1">
            <SkeletonLine className="w-48 mb-2" />
            <SkeletonLine className="w-full" />
          </div>
          <SkeletonLine className="w-12" />
        </div>
      </div>
    ))}
  </div>
);

export const InjectSkeletonKeyframes = () => (
  <style>{`
    @keyframes netluq-shimmer {
      0% { background-position: 120% 0; }
      100% { background-position: -120% 0; }
    }
  `}</style>
);

